var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinB3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0087 2.01183L6.99159 2C6.44065 1.99935 5.99041 2.44959 5.99106 3.00053C5.99171 3.55146 6.44301 4.00276 6.99395 4.00341L7.99566 4.0046L8.00157 9.01313C8.00354 10.676 6.66283 12.0167 5 12.0147L5.00236 14.0181L10.9826 14.0252L10.9908 21.0371L11.9937 22.04L12.9942 21.0395L12.986 14.0275L19.0263 14.0347L19.0239 12.0313C17.3611 12.0293 16.0172 10.6854 16.0152 9.02259L16.0093 4.01406L17.011 4.01524C17.562 4.01589 18.0122 3.56565 18.0115 3.01472C18.0109 2.46378 17.5596 2.01248 17.0087 2.01183Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinB3);
export default __webpack_public_path__ + "static/media/pin_b3.0d7086168c5a7f22e97d25dff3843a58.svg";
export { ForwardRef as ReactComponent };